/**
 * @generated SignedSource<<3cd3ca363b7ef4da69a18e1835fe7605>>
 * @relayHash 1e3a9c9e10fa41c68b2856a4ac4e2fa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b957aa9d6b2dbcc23cdf3659001a4454a1e74a1e5f81b11d103631a7002abe0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessListAppQuery } from './JiraBusinessListAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessListAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9b957aa9d6b2dbcc23cdf3659001a4454a1e74a1e5f81b11d103631a7002abe0",
    "metadata": {},
    "name": "JiraBusinessListAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
